import ConfettiImage from '@assets/images/confetti-2.png';

import styles from './success.module.css';

type SuccessProps = {
  onBack: () => void;
};

export const Success = ({ onBack }: SuccessProps) => {
  return (
    <section className={styles.sent}>
      <div className={styles.header}>
        <div className={styles.titleRow}>
          <h1 className={styles.title}>
            We sent you
            <br />a link
          </h1>
          <img
            className={styles.confetti}
            src={ConfettiImage}
            alt=""
            aria-hidden
          />
        </div>
        <p className={styles.subtitle}>
          Open link at your email for reset your password
        </p>
      </div>
      <button className={styles.link} type="button" onClick={onBack}>
        Didn&apos;t receive a email?
      </button>
    </section>
  );
};
